import { Popconfirm } from 'antd';
import { AppTable } from 'shared/UI/UIKit/Table';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppMultipleSelect } from 'shared/UI/UIKit/Select';
import { educationParallelTextRepresentation } from 'entities/education-class';
import type { SubjectRow, TeacherWorkloadFormProps } from 'entities/teacher-workload/form/types';
import type { EducationClass } from 'services/api/educationClasses/types';
import { useSubjectsTable } from './use-subjects-table';
import styles from './styles.module.scss';

type SubjectsTableProps = Pick<
  TeacherWorkloadFormProps,
  | 'availableSubjects'
  | 'subjectsLoading'
  | 'form'
  | 'setError'
  | 'initialDataSource'
  | 'availableEducationClasses'
>;

export const SubjectsTable = ({
  availableSubjects,
  subjectsLoading,
  form,
  setError,
  initialDataSource,
  availableEducationClasses,
}: SubjectsTableProps) => {
  const {
    state: { columns, dataSource, selectedTableRowsKeys },
    methods: {
      handleAddRow,
      handleSelectedTableRowsChange,
      handleClearSelectedClasses,
      handleOnChangeSelectedClasses,
      handleSaveChangedClasses,
      handleCancelChangedClasses,
    },
  } = useSubjectsTable({
    availableSubjects,
    subjectsLoading,
    form,
    setError,
    initialDataSource,
    availableEducationClasses,
  });

  return (
    <>
      {selectedTableRowsKeys.length > 0 && (
        <AppFlex direction="row" justifyContent="flex-end" style={{ marginBottom: 16 }}>
          <Popconfirm
            title={
              <AppMultipleSelect
                options={
                  availableEducationClasses?.map((educationalClass: EducationClass) => ({
                    label: `${educationParallelTextRepresentation[educationalClass.parallel]}${
                      educationalClass.litera
                    } класс`,
                    value: educationalClass.id,
                  })) || []
                }
                style={{ width: '100%', height: 'auto' }}
                getPopupContainer={(node) => node.parentElement!}
                onChange={handleOnChangeSelectedClasses}
              />
            }
            icon={null}
            placement="bottom"
            okText="Применить"
            cancelText="Отмена"
            overlayClassName={styles.popconfirm}
            onConfirm={handleSaveChangedClasses}
            onCancel={handleCancelChangedClasses}
          >
            <AppButton>Заменить классы</AppButton>
          </Popconfirm>
          <AppButton type="outline" color="danger" onClick={handleClearSelectedClasses}>
            Очистить классы
          </AppButton>
        </AppFlex>
      )}
      <AppTable
        columns={columns}
        dataSource={dataSource}
        rowKey={(record: SubjectRow) => record.key}
        size="small"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys: selectedTableRowsKeys,
          onChange: (selectedKeys) => handleSelectedTableRowsChange(selectedKeys),
        }}
      />

      <div style={{ marginTop: 16 }}>
        <AppButton onClick={handleAddRow} type="outline" htmlType="button">
          Добавить предмет
        </AppButton>
      </div>
    </>
  );
};
